// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1AwDE","inputWrap":"CustomTip_inputWrap__1PdzY"};